export default [
  {
    path: '/authentication/face/twoElements',
    name: 'faceTwoElements',
    component: () => import('@/views/authentication/face/twoElements.vue'),
    meta: {
      title: '个人身份认证服务',
    },
  },
  {
    path: '/authentication/face/faceFirst',
    name: 'faceFirst',
    component: () => import('@/views/authentication/face/faceFirst.vue'),
    meta: {
      title: '人脸认证',
    },
  },
  {
    path: '/authentication/face/faceSecond',
    name: 'faceSecond',
    component: () => import('@/views/authentication/face/faceSecond.vue'),
    meta: {
      title: '人脸认证',
    },
  },
  {
    path: '/authentication/face/faceSecondAndroid',
    name: 'faceSecondAndroid',
    component: () =>
      import('@/views/authentication/face/faceSecondAndroid.vue'),
    meta: {
      title: '人脸认证',
    },
  },
  {
    path: '/authentication/face/guide',
    name: 'faceGuide',
    component: () => import('@/views/authentication/face/guide.vue'),
    meta: {
      title: '人脸认证',
    },
  },
  {
    path: '/authentication/face/face_webrtc',
    name: 'faceWebrtc',
    component: () => import('@/views/authentication/face/face_webrtc.vue'),
    meta: {
      title: '人脸认证',
    },
  },
  {
    path: '/authentication/face/webrtc_result',
    name: 'faceWebrtcResult',
    component: () => import('@/views/authentication/face/webrtc_result.vue'),
    meta: {
      title: '认证成功',
    },
  },
  {
    path: '/authentication/face/result',
    name: 'faceResult',
    component: () => import('@/views/authentication/face/result.vue'),
    meta: {
      title: '认证结果',
    },
  },
]
